import { Component, Input } from '@angular/core';
import { LowerCasePipe } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { UnderlineLinkComponent } from '@atoms/underline-link/underline-link.component';
import { StickerComponent } from '@atoms/sticker/sticker.component';
import { ScrolltoDirective } from '@directives/scrollto.directive';
import { PricePipe } from '@pipes/price.pipe';
import { CarPrice } from '@models/car.model';

@Component({
  selector: 'app-car-detail-header-right',
  imports: [LowerCasePipe, TranslateModule, StickerComponent, ScrolltoDirective, PricePipe, UnderlineLinkComponent],
  templateUrl: './car-detail-header-right.component.html',
  styleUrl: './car-detail-header-right.component.scss',
})
export class CarDetailHeaderRightComponent {
  @Input() price?: CarPrice;
  @Input('monthly-payment') monthlyPayment?: number;
  @Input('in-stock') inStock?: boolean;
  @Input('branch-id') branchId?: number;
}
